import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { saleSetRegisterApi } from "../../../api/dich-vu/saleSetRegisterApi";
import { saleSetRegisterTypeApi } from "../../../api/dich-vu/saleSetRegisterTypeApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eSaleSetRegisterActionTypeIds,
	ISaleSetRegisterLoadStart,
	ISaleSetRegisterSaveStart,
	ISaleSetRegisterTypeByHocSinhLoadStart
} from "../../action-types/dich-vu/ISaleSetRegisterActionTypes";
import { saleSetRegisterActions } from "../../actions/dich-vu/saleSetRegisterActions";

export function* saleSetRegisterSaga(): any {
	yield takeLatest(eSaleSetRegisterActionTypeIds.LOAD_START, loadSaleSetRegisterWorker)
	yield takeLatest(eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_START, loadSaleSetRegisterTypeWorker)
	yield takeLatest(eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_START, loadSaleSetRegisterTypeByHocSinhWorker)
	yield takeEvery(eSaleSetRegisterActionTypeIds.SAVE_START, saveSaleSetRegisterWorker)
}

function* loadSaleSetRegisterWorker(action: ISaleSetRegisterLoadStart): any {
	const res: IBaseResponeModel = yield call([saleSetRegisterApi, saleSetRegisterApi.SelectHinhThucNopPhi], action.payload)
	if (res.is_success) {
		yield put(saleSetRegisterActions.loadSaleSetRegisterSuccess(res.data || []))
	} else {
		yield put(saleSetRegisterActions.loadSaleSetRegisterError(res.message || "Không tải được danh sách đăng ký hình thức nộp phí"))
	}
}

function* loadSaleSetRegisterTypeWorker(): any {
	const res: IBaseResponeModel = yield call([saleSetRegisterTypeApi, saleSetRegisterTypeApi.SelectAll])
	if (res.is_success) {
		yield put(saleSetRegisterActions.loadSaleSetRegisterTypeSuccess(res.data || []))
	} else {
		yield put(saleSetRegisterActions.loadSaleSetRegisterTypeError(res.message || "Không tải được danh sách hình thức nộp phí"))
	}
}

function* loadSaleSetRegisterTypeByHocSinhWorker(action: ISaleSetRegisterTypeByHocSinhLoadStart): any {
	const res: IBaseResponeModel = yield call([saleSetRegisterTypeApi, saleSetRegisterTypeApi.SelectByHocSinh], action.payload)
	if (res.is_success) {
		yield put(saleSetRegisterActions.loadSaleSetRegisterTypeByHocSinhSuccess(res.data || []))
	} else {
		yield put(saleSetRegisterActions.loadSaleSetRegisterTypeByHocSinhError(res.message || "Không tải được hình thức đã đăng ký của học sinh"))
	}
}

function* saveSaleSetRegisterWorker(action: ISaleSetRegisterSaveStart): any {
	const res: IBaseResponeModel = yield call([saleSetRegisterApi, saleSetRegisterApi.InsertMultiple], action.payload)
	if (res.is_success) {
		yield put(saleSetRegisterActions.saveSaleSetRegisterSuccess())
	} else {
		yield put(saleSetRegisterActions.saveSaleSetRegisterError(res.message || "Không lưu được đăng ký hình thức nộp phí"))
	}
}
